import type * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ArticleCard } from '@xing-com/crate-career-hub-article-card';
import type { CareerHubArticleFragmentFragment } from '@xing-com/crate-career-hub-topics';
import { scale360, spaceL } from '@xing-com/tokens';

import { Styled } from './topic-carousel.styles';

export type TopicCarouselType = {
  articles: (CareerHubArticleFragmentFragment | null)[];
};

export const TopicCarousel: React.FC<TopicCarouselType> = ({ articles }) => (
  <>
    <Styled.Headline size="xxlarge">
      <FormattedMessage id="CAREER_HUB_TOPIC_CAROUSEL_TITLE" />
    </Styled.Headline>
    <Styled.BodyCopy>
      <FormattedMessage id="CAREER_HUB_TOPIC_CAROUSEL_DESCRIPTION" />
    </Styled.BodyCopy>
    <Styled.Carousel
      itemMaxWidth={scale360}
      itemMinWidth={scale360}
      itemSpacing={spaceL}
      itemSpacingConfined={spaceL}
      itemSnapPosition="center"
    >
      {articles?.map(
        (article) =>
          article && (
            <ArticleCard
              key={article.url}
              {...{
                description: article.description,
                imageSrc: article.image?.srcWide ?? '',
                pageTitle: article.pageTitle,
                profileImage: article.pageLogos?.square48 ?? '',
                title: article.title,
                url: `${article?.url}?sc_o=career_hub_topic_page_article_click`,
              }}
            />
          )
      )}
    </Styled.Carousel>
    <Styled.Divider />
  </>
);
